<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && activity">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			[options]="false">
			<form
				#editForm="ngForm"
				[formReset]="editForm"
				(ngSubmit)="editForm.valid && submit()">

				<div
					class="modal-body non-modal"
					ngbAutofocus>

					<div
						class="row"
						*ngIf="objective">
						<div class="col-sm-12">

							<!-- objective -->
							<div class="row objective py-1">
								<div class="col-md-12">
									<h6>
										{{'labels.objective-data' | translate | uppercase}}
									</h6>
								</div>
								<div class="form-group col-md-4">
									<label>
										{{ 'labels.name' | translate }}:
										<a
											class="link"
											routerLink="/project/objective/edit/{{objective.id}}">
											<span style="font-weight: bold;">{{objective?.name}}</span>
										</a>

									</label>
								</div>
								<div class="form-group col-md-4">
									<label>
										{{ 'labels.startdate' | translate }}:
										<span style="font-weight: bold;">
											{{objective?.startdate | date:'dd/MM/yyyy'}}
										</span>
									</label>
								</div>
								<div class="form-group col-md-4">
									<label>
										{{ 'labels.stopdate' | translate }}:
										<span style="font-weight: bold;">
											{{objective?.stopdate | date:'dd/MM/yyyy'}}
										</span>
									</label>
								</div>
							</div>
							<br>
							<div class="row mb-3 no-internal-padding">
								<!-- name -->
								<div class="form-group col-md-3">
									<label for="cname">{{ 'labels.name' | translate }}*</label>
									<input
										[(ngModel)]="activity.name"
										#name="ngModel"
										name="name"
										required
										type="text"
										class="form-control"
										placeholder="{{ 'labels.name' | translate }}"
										[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
									<div
										class="invalid-feedback"
										*ngIf="editForm.submitted && name.invalid">
										{{'errors.required' | translate}}
									</div>
								</div>
								<div class="col-md-3">
									<label>{{'labels.type' | translate}}*</label>
									<select
										#taxonomy="ngModel"
										class="form-control custom-select"
										[(ngModel)]="activity.taxonomy"
										name="taxonomy">

										<option
											*ngFor="let type of activitytypes"
											[value]="type.value">
											{{('labels.'+type.value) | translate}}
										</option>
									</select>
									<div
										class="invalid-feedback"
										*ngIf="editForm.submitted && taxonomy.invalid">
										{{'errors.required' | translate}}
									</div>
								</div>
								<!-- startdate -->
								<div class="form-group col-md-3">
									<label>{{'labels.startdate' | translate}}*</label>
									<app-datepicker
										[(ngModel)]="activity.startdate"
										name="startdate"
										required
										#startdate="ngModel"
										[min]="objective?.startdateasdate"
										[max]="objective?.stopdateasdate"
										[ngClass]="{'is-invalid': editForm.submitted && startdate.invalid}">
									</app-datepicker>
									<div
										class="invalid-feedback"
										*ngIf="editForm.submitted && startdate.invalid"
										style="display: block;">
										{{'errors.required' | translate}}
									</div>
								</div>
								<!-- stopdate -->
								<div class="form-group col-md-3">
									<label>{{'labels.stopdate' | translate}}*</label>
									<app-datepicker
										[(ngModel)]="activity.stopdate"
										name="stopdate"
										required
										#stopdate="ngModel"
										[min]="max(objective?.startdateasdate, activity.startdateasdate)"
										[max]="objective?.stopdateasdate"
										[ngClass]="{'is-invalid': editForm.submitted && stopdate.invalid}">
									</app-datepicker>
									<div
										class="invalid-feedback"
										*ngIf="editForm.submitted && stopdate.invalid"
										style="display: block;">
										{{'errors.required' | translate}}
									</div>
								</div>
								<!-- description -->
								<div class="form-group col-md-12">
									<label>{{ 'labels.description' | translate }}*</label>
									<quill-editor
										name="description"
										[required]="true"
										[(ngModel)]="activity.description"
										placeholder
										#description="ngModel"
										[ngClass]="editForm.submitted && description.invalid ? 'is-invalid' : ''">
									</quill-editor>
									<div
										class="invalid-feedback"
										*ngIf="editForm.submitted && description.invalid">
										{{'errors.required' | translate}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="modal-footer non-modal-footer"
					*ngIf="activity && objective">

					<button
						routerLink="{{'/company/project/view/' + objective.projectid}}"
						fragment="obiettivi"
						type="button"
						class="btn btn-primary">
						{{'labels.cancel' | translate}}
					</button>
					<button
						type="submit"
						class="btn btn-primary">
						{{'labels.save' | translate}}
					</button>
				</div>
			</form>
		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.activity' | translate}}
		</app-card>

	</div>
</div>
